<template>
  <section class="hulp">
    <Container>
      <Title>Hulp</Title>
      <Content small>
        <p>Heb je zelf last van psychische problemen? Daar kan je met mensen over praten of appen. Kijk op de site van <a href="https://mindkorrelatie.nl/footer-contact/contact" target="_blank">MIND Korrelatie</a> voor meer info.</p>
      </Content>
    </Container>
  </section>
</template>

<script>
import { Title, Content, Container } from '@/components/chapter'
import { chapterMixin } from '@/mixins'

export default {
  name: 'Hulp',
  mixins: [chapterMixin],
  components: {
    Title,
    Content,
    Container
  }
}
</script>

<style lang="scss" scoped>
.hulp {
  padding-top: 70px;
  padding-bottom: 50px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/chapters/Hulp.vue